import React, { useEffect, useRef, useState } from "react";
import "./RechargeModal.scss";
import { useDispatch, useSelector } from "react-redux";
import { rechargeWalletAmount } from "../../redux/actions/VendorCandidateDetails";
import ButtonSpinner from "../ReusableComponents/ButtonSpinner";
import { payBaseUrl } from "../../constant/baseurl";

const RechargeModal = ({ handleRechargeWallet }) => {
  const accessData = useSelector((state) => state.getClientAccessControl.data);
  const rechargeWalletAmountLoading = useSelector((state)=>state?.rechargeWallet?.loading)
  const dispatch = useDispatch();
  const formRef = useRef(null);
  const [encryptedRequest, setEncryptedRequest] = useState("");
  const [accessCode, setAccessCode] = useState("");
  const [ccUrl, setccUrl] = useState("");
  const clientInfoID = localStorage.getItem("client_info_id");
  const masterID = localStorage.getItem("master_id");
  const [formData, setFormData] = useState({
    client_info_id: clientInfoID,
    master_id: masterID,
    recharge_amount: "",
    redirect_url:
      `${payBaseUrl}/valiantinfo_app/Wallet_service/response_for_recharge_wallet_amount/`,
      // "https://dev.valianttinfo.com/valiantinfo_app/Wallet_service/response_for_recharge_wallet_amount/",
    redirect_to: window.location.href,
  });
  const handleRechargeAmountChange = (e) => {
    const amount = e.target.value.replace(/\D/g, "");
    setFormData((prev) => ({ ...prev, recharge_amount: amount }));
  };

  const successFn = (res) => {
    setEncryptedRequest(res.data.encryption);
    setAccessCode(res.data.access_code);
    setccUrl(res.data.cc_url);
    setTimeout(() => {
      formRef.current?.submit();
    }, 500);
  };

  const failureFn = (err) => {
    console.error(err);
  };
  const handleRechargeSubmit = (e) => {
    if (!formData.recharge_amount) {
  alert("Please enter the amount");
} else if (isNaN(formData.recharge_amount) || formData.recharge_amount <= 0) {
  alert("Please enter a valid amount");
}

    e.preventDefault();
    console.log("form submitted");
    console.log(formData);

    dispatch(rechargeWalletAmount({ data: formData, successFn, failureFn }));
  };

  return (
    <main className='rechargeModal'>
      <article className='Content'>
        <div className='HeaderClose'>
          <h1 className='ModalHeader Ellipsis'>Wallet Recharge</h1>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='1.5rem'
            height='1.5rem'
            viewBox='0 0 30 30'
            fill='none'
            onClick={handleRechargeWallet}>
            <path
              d='M16.7624 15.0002L24.6374 7.13773C24.8728 6.90235 25.005 6.58311 25.005 6.25023C25.005 5.91735 24.8728 5.59811 24.6374 5.36273C24.402 5.12735 24.0828 4.99512 23.7499 4.99512C23.417 4.99512 23.0978 5.12735 22.8624 5.36273L14.9999 13.2377L7.13742 5.36273C6.90204 5.12735 6.5828 4.99512 6.24992 4.99512C5.91705 4.99512 5.5978 5.12735 5.36242 5.36273C5.12704 5.59811 4.99481 5.91735 4.99481 6.25023C4.99481 6.58311 5.12704 6.90235 5.36242 7.13773L13.2374 15.0002L5.36242 22.8627C5.24526 22.9789 5.15227 23.1172 5.08881 23.2695C5.02535 23.4218 4.99268 23.5852 4.99268 23.7502C4.99268 23.9152 5.02535 24.0786 5.08881 24.231C5.15227 24.3833 5.24526 24.5215 5.36242 24.6377C5.47863 24.7549 5.61688 24.8479 5.7692 24.9113C5.92153 24.9748 6.08491 25.0075 6.24992 25.0075C6.41494 25.0075 6.57832 24.9748 6.73064 24.9113C6.88297 24.8479 7.02122 24.7549 7.13742 24.6377L14.9999 16.7627L22.8624 24.6377C22.9786 24.7549 23.1169 24.8479 23.2692 24.9113C23.4215 24.9748 23.5849 25.0075 23.7499 25.0075C23.9149 25.0075 24.0783 24.9748 24.2306 24.9113C24.383 24.8479 24.5212 24.7549 24.6374 24.6377C24.7546 24.5215 24.8476 24.3833 24.911 24.231C24.9745 24.0786 25.0072 23.9152 25.0072 23.7502C25.0072 23.5852 24.9745 23.4218 24.911 23.2695C24.8476 23.1172 24.7546 22.9789 24.6374 22.8627L16.7624 15.0002Z'
              fill='black'
            />
          </svg>
        </div>
        <div className='contentContainer'>
          <div className='currentBalance'>
            <p>Your Current Balance</p>
            <p> ₹ {accessData?.data?.wallet_balance || 0}</p>
          </div>
          <form
            className='rechargeInputForm'
            onSubmit={handleRechargeSubmit}>
            <div className='rechargeInputContainer'>
              <input
                className='rechargeInput'
                placeholder='Enter Recharge Amount'
                autoFocus
                onChange={handleRechargeAmountChange}
                value={formData.recharge_amount}
                maxLength={8}
              />
            </div>
            <button
              type='submit'
              className='confirmBtn'>
                {rechargeWalletAmountLoading ? <ButtonSpinner color="var(--AccentColor)" /> : 'Confirm'}
             </button>
          </form>
        </div>
        {encryptedRequest && accessCode && ccUrl && (
          <form
            ref={formRef}
            method='post'
            action={ccUrl}>
            <input
              type='hidden'
              name='encRequest'
              value={encryptedRequest}
            />
            <input
              type='hidden'
              name='access_code'
              value={accessCode}
            />
          </form>
        )}
      </article>
    </main>
  );
};

export default RechargeModal;
